import { useState } from 'react';
import { SalifyLogo } from './Logo';
import type { AppPage } from './LandingPage';

interface NavProps {
  currentPage: AppPage;
  onNavigate: (page: AppPage) => void;
  onGetStarted: () => void;
  onLogin: () => void;
  isAuthenticated?: boolean;
}

export function Nav({ currentPage, onNavigate, onGetStarted, onLogin, isAuthenticated }: NavProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = (page: AppPage) => {
    onNavigate(page);
    setMenuOpen(false);
  };

  return (
    <nav className="lp-nav">
      <div className="lp-nav-inner">
      <button className="lp-nav-brand nav-brand-btn" onClick={() => navigate('home')}>
        <SalifyLogo size={26} fontSize={20} gap={7} />
      </button>

      <div className="lp-nav-links">
        <button
          onClick={() => navigate('features')}
          className={`lp-nav-link lp-nav-link-btn${currentPage === 'features' ? ' lp-nav-link--active' : ''}`}
        >
          Features
        </button>
        <button
          onClick={() => navigate('how-it-works')}
          className={`lp-nav-link lp-nav-link-btn${currentPage === 'how-it-works' ? ' lp-nav-link--active' : ''}`}
        >
          How it works
        </button>
        <button
          onClick={() => navigate('pricing')}
          className={`lp-nav-link lp-nav-link-btn${currentPage === 'pricing' ? ' lp-nav-link--active' : ''}`}
        >
          Pricing
        </button>
        <button
          onClick={() => navigate('changelog')}
          className={`lp-nav-link lp-nav-link-btn${currentPage === 'changelog' ? ' lp-nav-link--active' : ''}`}
        >
          Changelog
        </button>
      </div>

      <div className="lp-nav-actions">
        {isAuthenticated ? (
          <button className="btn btn-primary lp-nav-cta" onClick={() => navigate('home')}>Dashboard</button>
        ) : (
          <>
            <button className="btn btn-ghost" onClick={onLogin}>Log in</button>
            <button className="btn btn-primary lp-nav-cta" onClick={onGetStarted}>Get started free</button>
          </>
        )}
      </div>

      <button
        className={`lp-nav-burger${menuOpen ? ' lp-nav-burger--open' : ''}`}
        onClick={() => setMenuOpen(o => !o)}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
      >
        <span />
        <span />
        <span />
      </button>
      </div>

      {menuOpen && (
        <div className="lp-mobile-menu">
          <button
            onClick={() => navigate('features')}
            className={`lp-mobile-link${currentPage === 'features' ? ' lp-mobile-link--active' : ''}`}
          >
            Features
          </button>
          <button
            onClick={() => navigate('how-it-works')}
            className={`lp-mobile-link${currentPage === 'how-it-works' ? ' lp-mobile-link--active' : ''}`}
          >
            How it works
          </button>
          <button
            onClick={() => navigate('pricing')}
            className={`lp-mobile-link${currentPage === 'pricing' ? ' lp-mobile-link--active' : ''}`}
          >
            Pricing
          </button>
          <button
            onClick={() => navigate('changelog')}
            className={`lp-mobile-link${currentPage === 'changelog' ? ' lp-mobile-link--active' : ''}`}
          >
            Changelog
          </button>
          <div className="lp-mobile-actions">
            {isAuthenticated ? (
              <button className="btn btn-primary" style={{ width: '100%' }} onClick={() => { navigate('home'); }}>Dashboard</button>
            ) : (
              <>
                <button className="btn btn-ghost" onClick={() => { onLogin(); setMenuOpen(false); }}>Log in</button>
                <button className="btn btn-primary" onClick={() => { onGetStarted(); setMenuOpen(false); }}>Get started free</button>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
